import { Permission } from "@/shared/auth/permissions";
import { useCanDo } from "@/shared/auth/use-can-do";

export function useCanEditCompanyDetails(): boolean {
  const canEditSettings = useCanDo(Permission.WORKSPACE_EDIT_SETTINGS);
  const canManagePayroll = useCanDo(Permission.PAYROLL_CONFIG_MANAGE);
  return canEditSettings || canManagePayroll;
}
